import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(() => http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)), []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    const off = () => setUser(false);
    window.addEventListener("dainuok:unauthorized", off);
    return () => window.removeEventListener("dainuok:unauthorized", off);
  }, []);

  const logout = useCallback(async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, logout, checkAuth }), [user, logout, checkAuth]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
